import { Text } from '@thanx/uikit/text'
import { ReactComponent as BrameLogo } from 'assets/images/integrations/logos/img_brame.svg'
import StatusBadge from 'components/StatusBadge'
import { buildTranslate } from 'locales'
import React, { ReactNode } from 'react'
import { Container } from 'react-bootstrap-five'
import { merchantTheme } from 'theme'

const t = buildTranslate('games')

interface GamesHeaderProps {
  children?: ReactNode
}

const GamesHeader: React.FC<GamesHeaderProps> = ({ children }) => {
  const { colors } = merchantTheme

  return (
    <div className="bg-white">
      <Container className="pl-0 py-l">
        <div className="d-flex align-items-center mb-xs">
          <StatusBadge type="beta" className="ml-0" />
        </div>

        <Text.Header2 className="mb-xs mt-xs">{t('header.title')}</Text.Header2>

        <div className="d-flex align-items-center mb-l">
          <Text.BodyText4 color={colors.grey70}>
            {t('header.poweredBy')}
          </Text.BodyText4>
          <BrameLogo width={80} height={16} />
        </div>
      </Container>

      {children && <Container className="pl-0">{children}</Container>}

      <div className="border-bottom-1 grey-20-border" />
    </div>
  )
}

export default GamesHeader
